import { cn } from "@omni/utils/styles";

import { useAccordionItemContext } from "@/components/General/Faq/context/accordionItem.context";
import { useFaqContext } from "@/components/General/Faq/context/faq.context";

type Props = {
    className?: string;
};

export const Question = ({ className }: Props) => {
    const { question, open } = useAccordionItemContext();
    const { onToggleQuestion } = useFaqContext();

    const handleOnClick = () => {
        onToggleQuestion(question);
    };

    return (
        <h4
            className={cn(
                "tw:border-b tw:border-grey-light tw:mb-2 tw:mt-0 tw:py-4 tw:flex tw:items-center tw:justify-between tw:w-full tw:cursor-pointer tw:font-bold tw:text-lg",
                className
            )}
            color={"link"}
            onClick={handleOnClick}
        >
            {question.title}
            <i
                className={cn("las", "tw:mr-2", {
                    "la-plus": !open,
                    "la-minus": open
                })}
            />
        </h4>
    );
};
